import React, { useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useNotification } from '../../../hooks/useNotification';
import { useDataAuth } from '../../../hooks/useDataAuth';

import { DialogConfirmAction } from '../../dialogs/DialogConfirmAction';
import { Navigation } from '../../others/Navigation';
import { GenericModal } from '../../others/GenericModal';
import { Filter } from '../../charts/Filter';
import { ActionIconItem } from '../../others/ActionIconItem';
import ChatBot from '../../chatagent/ChatBot';

import { ModalForms } from './ModalForms';
import { evaluateCondition } from '../../../utils/evaluateCondition';
import useResolveCompanyInfo from '../../../hooks/useResolveCompanyInfo';
import { ensureArray } from '../../../utils/validateResponseApi';
import { PopUpSharedTable } from '../../../screens/sharedViews/components/PopUpSharedTable';
import { resolveActionConfig } from '../../../helpers/configResolver';
import { safeParseJSONNotRef } from '../../../utils/jsonValidator';

export const LoadButtonHeaderTable = ({ buttons, id_user_action, parent, DocManager = [], columns = [], handleChange = () => { }, data = null }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const companyInfo = useResolveCompanyInfo();
    const [openLoadingOverlay, setopenLoadingOverlay] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);

    // GENERIC COMPONENTS MODALS
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = (item) => setOpenModal(item);

    const CallApi = async (trigger, name, requires_check) => {
        const filters = {};
        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            filters.id_unique = {
                "value": prnt.id_unique,
                "operator": "=",
                "type": "string"
            }
            if (DocManager?.rowsCheckedDetails.length > 0)
                filters.id = {
                    "value": DocManager?.rowsCheckedDetails.join(","),
                    "operator": "IN",
                    "type": "string"
                }
        } else {
            filters.id_unique = {
                "value": DocManager?.rowsChecked.join(","),
                "operator": "IN",
                "type": "string"
            }
        }
        const filt = JSON.stringify({ filters });
        let ext = name.split('.').pop();
        let bodyData = trigger[0]?.bodyData;
        const url = trigger[0]?.url;
        const method = trigger[0]?.method;
        if (requires_check === 'true') {
            if (DocManager?.rowsChecked.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                bodyData.variables = filt
            else {
                sendNotification({ msg: t("messages.selectAtLeastOneRow"), variant: 'error' });
                return false;
            }
        }
        else {
            if (DocManager?.rowsChecked.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                bodyData.variables = filt
            else {
                bodyData.variables = JSON.stringify({ filters: DocManager?.filters });
            }
        }

        const header = columns.reduce((acc, col) => {
            if (col.visible)
                acc[col.label] = `{${col.id}}`;
            return acc;
        }, {});

        bodyData.schema = header;
        bodyData.id_user_action = id_user_action;
        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            bodyData.parent = prnt;
        }

        let config = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: JSON.stringify(bodyData)
        };
        sendNotification({ msg: t("messages.fileGenerating"), variant: 'success' });
        // handleRowsChecked([]);
        try {
            const response = await axios.request(config);
            if (response.status === 200) {
                console.log("response ", response);
                const byteCharacters = atob(response.data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: `application/${ext}` });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name.replace('{date}', moment().format('YYYY-MM-DDTHH:mm:ssZ')));
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            else
                sendNotification({ msg: t("messages.errorGeneralAlert"), variant: 'error' });
        } catch (error) {
            console.error(error);
        }
    }

    const [tittleDiealog, setTittleDiealog] = useState('');
    const [trigger, setTrigger] = useState(null);
    const [requiredC, setRequiredCheck] = useState('');
    const OpenConfirmation = (param, param2, param3) => {
        setOpenConfirmation(true);
        setTrigger(param);
        setRequiredCheck(param2);
        setTittleDiealog(param3);
    }

    const CallApiTrigger = async () => {
        setopenLoadingOverlay(true);
        const filters = {};
        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            filters.id_unique = {
                "value": prnt.id_unique,
                "operator": "=",
                "type": "string"
            }
            if (DocManager?.rowsCheckedDetails.length > 0)
                filters.id = {
                    "value": DocManager?.rowsCheckedDetails.join(","),
                    "operator": "IN",
                    "type": "string"
                }
        } else {
            filters.id_unique = {
                "value": DocManager?.rowsChecked.join(","),
                "operator": "IN",
                "type": "string"
            }
        }
        const filt = JSON.stringify({ filters })
        const resolvedTrigger = resolveActionConfig(trigger[0], parent || data, companyInfo);
        const bodyData = safeParseJSONNotRef(resolvedTrigger?.bodyData);
        const url = resolvedTrigger?.url;
        const method = resolvedTrigger?.method;
        bodyData.id_user_action = id_user_action;

        if (requiredC === 'true' && !DocManager?.rowsChecked.length > 0) {
            sendNotification({ msg: t("messages.selectAtLeastOneRow"), variant: 'error' });
            setopenLoadingOverlay(false);
            return false;
        }

        if (parent) {
            const prnt = { ...parent };
            delete prnt.propiedad;
            bodyData.parent = prnt;
        }

        bodyData.variables = filt;//variables || "{}";
        let config = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: JSON.stringify(bodyData)
        };

        console.log('bodyData ', bodyData);
        console.log(JSON.stringify(bodyData));

        try {
            const response = await axios.request(config);
            console.log('response ', response);
            if (response.status === 200) {
                setOpenConfirmation(false);
                sendNotification({ msg: t("messages.saveSuccess"), variant: 'success' });
                setTimeout(() => {
                    handleChange();
                }, 500);
            }
            else if (response.status === 504 && response.status === 408) {
                sendNotification({ msg: t("messages.processRunning"), variant: 'info' });
                setOpenConfirmation(false);
            }
            else
                sendNotification({ msg: t("messages.errorGeneralAlert"), variant: 'error' });
        } catch (error) {
            if (error.response?.status === 504)
                sendNotification({ msg: t("messages.processRunning"), variant: 'info' });
            else
                sendNotification({ msg: t("messages.errorGeneralAlert"), variant: 'error' });
            console.error('ERROR ==> ', error);
        }
        setopenLoadingOverlay(false);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        handleChange();
    };

    return (
        <>
            {
                ensureArray(buttons.filter((item) => evaluateCondition(item.visible, data, companyInfo)))
                    .map((item, index) => (
                        <>
                            {
                                item.type === 'download' && (
                                    <ActionIconItem
                                        item={item}
                                        onClick={(itemData) =>
                                            CallApi(itemData.trigger, itemData.name_file, itemData.requires_check)
                                        }
                                        height={35}
                                    />
                                )
                            }
                            {
                                item.type === 'form' && (
                                    <ModalForms
                                        data={item}
                                        id_user_action={id_user_action}
                                        parent={parent}
                                        handleChange={handleChange}
                                        DocManager={DocManager}
                                        requires_check={item?.requires_check || 'false'}
                                    />
                                )
                            }
                            {
                                item.type === 'trigger' && (
                                    <ActionIconItem
                                        item={item}
                                        onClick={(itemData) =>
                                            OpenConfirmation(itemData.trigger, itemData.requires_check, itemData.accion)
                                        }
                                        height={35}
                                    />
                                )
                            }
                            {
                                item.type === 'Redirect' && (
                                    <Navigation item={item} data={parent || data || {}} companyInfo={companyInfo} height={35} />
                                )
                            }
                            {item.type === 'detailsTable' &&
                                <PopUpSharedTable
                                    item={item}
                                    data={data || parent}
                                    DocManager={DocManager}
                                    companyInfo={companyInfo}
                                    handleChange={() => item.refreshTable && handleChange()}
                                />
                            }
                            {
                                item.type === 'RedirectModal' && (
                                    <>
                                        <ActionIconItem
                                            item={item}
                                            onClick={() => handleOpenModal({
                                                ...item,
                                                config: resolveActionConfig(item.config, parent || data, companyInfo)
                                            })}
                                            height={35}
                                        />
                                        {openModal && (
                                            <GenericModal
                                                open={!!openModal}
                                                title={openModal.accion}
                                                accion={openModal.accion}
                                                handleClose={handleCloseModal}
                                                item={openModal}
                                                data={data || parent}
                                            />
                                        )}
                                    </>
                                )
                            }
                            {
                                item.type === 'filter' && (
                                    <Filter
                                        data={item}
                                        handleFilter={handleChange}
                                    />
                                )
                            }
                            {
                                item.type === 'chatBot' && (
                                    <ChatBot
                                        data={item}
                                    />
                                )
                            }
                            {
                                item.type === 'refresh' && (
                                    <ActionIconItem
                                        item={item}
                                        onClick={handleChange}
                                        height={35}
                                    />
                                )
                            }
                        </>
                    ))
            }


            <DialogConfirmAction
                openDialogConfirm={openConfirmation}
                openLoadingOverlay={openLoadingOverlay}
                setOpenDialogConfirm={() => setOpenConfirmation(false)}
                titleDialog={tittleDiealog}
                textConfirmAction={"¿Esta seguro que desea continuar?"}
                textButtonConfirm={"Aceptar"}
                textButtonCancel={"Cancelar"}
                handleConfirmAction={CallApiTrigger}
            />
        </>
    )
}